module.exports = __webpack_public_path__ + "img/gg.6dc55a9a.svg";